import React from 'react';
import { CardContainer } from './Card.styled';

interface ICard {
  children: React.ReactNode;
  onClick?: () => void;
}

export function Card ({ children, onClick }: ICard) {
  return <CardContainer onClick={onClick}>{children}</CardContainer>;
}
